<template>
  <div>
    <div class="tw-p-5">
      <jt-data-table
        v-if="datatable"
        id="jt-composition"
        :api-mode="false"
        :data="tableRegister.registros"
        :fields="datatable.columns"
        :buttons="isConsumerUnit ? datatable.buttons : []"
        :is-paginated="false"
        :title="titleTeble"
        :row-buttons="false"
        @action-button="actionButton"
      >
        <template v-slot:body="{ props }">
          <q-tr class="text-left">
            <q-td
              v-for="col in props.cols"
              :key="col.name"
              :props="props"
              style="color: #333"
            >
              <div v-if="col.field == 'date' && props.row['date']">
                <strong style="font-size: 14px">
                  {{ props.row["date"].split(" ")[0] }}
                </strong>
                <br />
                <span>
                  {{ $gettext("SCHEDULE") }}:
                  {{ props.row["date"].split(" ")[1] }}
                </span>
              </div>
              <div
                v-else-if="
                  col.field == 'description' && props.row['description']"
              >
                <span style="text-wrap: wrap;">
                {{ col.value }}
              </span>
              </div>
              <span v-else>
                {{ col.value }}
              </span>
            </q-td>
          </q-tr>
          <q-tr v-show="props.expand" :props="props">
            <q-td colspan="100%">
              <div class="row hidden-row">
                <div
                  v-for="(col, key) in hiddenColumns"
                  :key="key"
                  class="col-6"
                >
                  <label>{{ col.label }}:</label>
                  {{ props.row[col.model] }}
                </div>
              </div>
            </q-td>
          </q-tr>
        </template>
      </jt-data-table>
    </div>
    <modal
      ref="includModal"
      :show="flModal"
      :forms="forms"
      :label="this.$gettext('INCLUDE')"
      @action-button="actionButtonModal"
    />
  </div>
</template>

<script>
import { Component, Vue, Watch } from 'vue-property-decorator'
import { Dialog } from 'quasar'
import ServiceObservationController from './ServiceObservationController'
import { JtDataTable, JtCrud } from 'jtech-webcomps'
import ServiceRequestController from '../../../ServiceRequestController'
import { GlobalController } from 'src/shared/global/GlobalController'
import { repository } from 'jtech'
import moment from 'moment'
const { modal } = JtCrud

@Component({
  name: 'ServiceObservation',
  components: { JtDataTable, modal, Dialog },
  props: {
    tableRegister: Array,
    datatable: Object,
    flOpenModal: Boolean,
    isConsumerUnit: Boolean
  }
})
class ObservationTable extends Vue {
  serviceObservationController = ServiceObservationController.getInstance();
  controller = ServiceRequestController.getInstance();
  globalController = GlobalController.getInstance()
  flModal = false;
  pageDialog = null;
  forms = null;

  actionButton (button, params, context) {
    this.openModal()
  }

  async openModal () {
    this.forms = await this.serviceObservationController.loadForm()
    this.flModal = true
  }

  async actionButtonModal (button, params) {
    if (this.isConsumerUnit) {
      const date = new Date()
      const offsetInMinutes = date.getTimezoneOffset()
      const localTime = new Date(date.getTime() - offsetInMinutes * 60000)
      const localIsoDateString = localTime.toISOString().slice(0, -1) + 'Z'
      this.tableRegister.registros.push({
        date: moment(date).format('DD/MM/YYYY HH:mm:ss'),
        user: this.globalController.profile.name,
        description: params.description
      })
      const { registros } = await repository.resolveDatatableModel('userWasteProfile.pesquisarUserById', {
        id: this.globalController.profile.id
      })
      const userWasteId = registros[0].userWaste
      this.$emit('add-observation', { date: localIsoDateString, userWaste: userWasteId, note: params.description })
    } else {
      await this.serviceObservationController.createServiceObservation({ ...params, consumerUnit: this.controller.routerStore.params.consumerUnit })
    }
    this.flModal = false
    this.$emit('closeModal')
  }

  @Watch('flOpenModal')
  onFlOpenModalChange (value, oldValue) {
    if (value === true) {
      this.openModal()
    }
  }
}
export default ObservationTable
</script>
<style lang="stylus" scoped>
</style>
